import _ from 'lodash';
import {
    FETCH_AI_COMMANDS,
    CLEAN_AI_COMMANDS,
    COMMENT_AI_COMMAND,
    DELETE_AI_COMMAND,
    RUN_AI_COMMAND,
} from './types';
import { request, __ } from '../functions';

export const fetchAiCommands = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/ai-commands', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_AI_COMMANDS, payload: data });
    });
};

export const commentAiCommand = (screen, id, comment) => {
    return dispatch => request(`/ai-commands/comment/${id}`, { comment }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa pridať poznámku'));
            return;
        }

        screen.showSnackbar('success', __('Poznámka bola pridaná'));

        dispatch({ type: COMMENT_AI_COMMAND, payload: { id, comment } });
    });
};

export const runAiCommand = (screen, id) => {
    return dispatch => request(`/ai-command-items/multiWaiting/${id}/all`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa spustiť úlohu'));
            return;
        }

        screen.showSnackbar('success', __('Úloha bola spustená'));

        dispatch({ type: RUN_AI_COMMAND, payload: id });
    });
};

export const deleteAiCommand = (screen, id) => {
    return dispatch => request(`/ai-commands/delete/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať úlohu'));
            return;
        }

        screen.showSnackbar('success', __('Úloha bola zmazaná'));

        dispatch({ type: DELETE_AI_COMMAND });
    });
};

export const cleanAiCommands = () => ({ type: CLEAN_AI_COMMANDS });
